import {IController} from "angular";
import * as angular from "angular";

export class routeStatusesMultipleSelectCtrl implements IController {
  statuses: any;
  noUnderline?: any;
  options?: any;
  ngPlaceholder: any;
  onChange: Function;

  constructor(private leanPlanningConstants, private $mdSelect) {
  }

  $onInit() {
    if (!this.options || !this.options.length) {
      this.options = this.leanPlanningConstants.routeStatuses;
    }
  };


  onReset() {
    this.onChange({statuses: []});
    this.$mdSelect.hide();
  }

  onCancel() {
    this.$mdSelect.hide();
  }

  onSelect() {
    this.onChange({statuses: this.statuses});
    this.$mdSelect.hide();
  }
}

angular
  .module('bringoz.admin.lean-planning')
  .component('routeStatusesMultipleSelect', {
    bindings: {
      statuses: '<',
      noUnderline: '<?',
      options: '<?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./route-statuses-multiple-select.html').default,
    controller: routeStatusesMultipleSelectCtrl
  });
